import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { FormatPrice } from 'utils/format';

const showRevenue = (carrier) =>
  (carrier.group || '').toLowerCase().indexOf('tier') !== -1 && carrier.revenue_target > 0;

const CarrierTarget = ({ intl, carrier }) => {
  const t = intl.messages.components.CarrierTarget;

  return (
    <span>
      {t.target} <b>{carrier.group || 'Default'}</b>&nbsp;&nbsp;
      {showRevenue(carrier) && (
        <span>
          {t.limit}{' '}
          <b>
            <FormatPrice currency={carrier.currency} value={carrier.revenue_target} />
          </b>
        </span>
      )}
    </span>
  );
};

CarrierTarget.propTypes = {
  carrier: PropTypes.object,
  intl: PropTypes.any,
};

export default injectIntl(CarrierTarget);
